import { createCanvas, loadImage } from 'canvas';

export const category = [
    {
        eng: 'hair',
        icon: <img src={process.env.PUBLIC_URL + '/assets/img/category/hair.svg'} alt='logo'></img>,
        name: '美容美髮'
    },
    {
        eng: 'eyebrow',
        icon: <img src={process.env.PUBLIC_URL + '/assets/img/category/eyebrow.svg'} alt='logo'></img>,
        name: '紋眉美睫'
    },
    {
        eng: 'nails',
        icon: <img src={process.env.PUBLIC_URL + '/assets/img/category/nails.svg'} alt='logo'></img>,
        name: '美甲'
    },
    {
        eng: 'plastic',
        icon: <img src={process.env.PUBLIC_URL + '/assets/img/category/plastic.svg'} alt='logo'></img>,
        name: '醫美'
    },
    {
        eng: 'massage',
        icon: <img src={process.env.PUBLIC_URL + '/assets/img/category/massage.svg'} alt='logo'></img>,
        name: '按摩舒壓'
    },
    {
        eng: 'fitness',
        icon: <img src={process.env.PUBLIC_URL + '/assets/img/category/fitness.svg'} alt='logo'></img>,
        name: '健身'
    },
    {
        eng: 'rent',
        icon: <img src={process.env.PUBLIC_URL + '/assets/img/category/rent.svg'} alt='logo'></img>,
        name: '場地租借'
    },
    {
        eng: 'health',
        icon: <img src={process.env.PUBLIC_URL + '/assets/img/category/health.svg'} alt='logo'></img>,
        name: '健康諮詢'
    },
    {
        eng: 'others',
        icon: <img src={process.env.PUBLIC_URL + '/assets/img/category/other.svg'} alt='logo'></img>,
        name: '其他'
    }
];

export const timeOptions = [
    "00:00",
    "00:30",
    "01:00",
    "01:30",
    "02:00",
    "02:30",
    "03:00",
    "03:30",
    "04:00",
    "04:30",
    "05:00",
    "05:30",
    "06:00",
    "06:30",
    "07:00",
    "07:30",
    "08:00",
    "08:30",
    "09:00",
    "09:30",
    "10:00",
    "10:30",
    "11:00",
    "11:30",
    "12:00",
    "12:30",
    "13:00",
    "13:30",
    "14:00",
    "14:30",
    "15:00",
    "15:30",
    "16:00",
    "16:30",
    "17:00",
    "17:30",
    "18:00",
    "18:30",
    "19:00",
    "19:30",
    "20:00",
    "20:30",
    "21:00",
    "21:30",
    "22:00",
    "22:30",
    "23:00",
    "23:30"
];

export const toogleWeeks = {
    'sun': '星期日',
    'mon': '星期ㄧ',
    'tue': '星期二',
    'wed': '星期三',
    'thu': '星期四',
    'fri': '星期五',
    'sat': '星期六',
};

// Resize Image
export const compressImage = async (file, maxSize, quality) => {
    const imageUrl = URL.createObjectURL(file);
    const img = await loadImage(imageUrl);
    const canvas = createCanvas(img.width, img.height);
    const ctx = canvas.getContext('2d');
    let width = img.width;
    let height = img.height;

    if (width > height) {
        if (width > maxSize) {
            height *= maxSize / width;
            width = maxSize;
        }
    } else {
        if (height > maxSize) {
            width *= maxSize / height;
            height = maxSize;
        }
    }
    canvas.width = width;
    canvas.height = height;
    ctx.drawImage(img, 0, 0, width, height);

    const mimeType = file.type;
    return new Promise((resolve, reject) => {
        canvas.toBlob((blob) => {
            resolve(new File([blob], file.name, { type: mimeType }));
        },
            mimeType, quality
        )
    });
};

// Resize Image
export const compressImageWithMinSize = async (file, minSize, quality) => {
    const imageUrl = URL.createObjectURL(file);
    const img = await loadImage(imageUrl);
    const canvas = createCanvas(img.width, img.height);
    const ctx = canvas.getContext('2d');
    let width = img.width;
    let height = img.height;

    if (width > height) {
        if (height > minSize) {
            width *= minSize / height;
            height = minSize;
        }
    } else {
        if (width > minSize) {
            height *= minSize / width;
            width = minSize;
        }
    }
    canvas.width = width;
    canvas.height = height;
    ctx.drawImage(img, 0, 0, width, height);

    const mimeType = file.type;
    return new Promise((resolve, reject) => {
        canvas.toBlob((blob) => {
            resolve(new File([blob], file.name, { type: mimeType }));
        },
            mimeType, quality
        )
    });
};
